import store from '@polleverywhere/redux'
import { slice as appSlice } from '../slices/app'
import { selectCustomStyle } from '../states/participant/redux/activePresenter'
import listenToSelector from '../util/listen_to_selector'
import { updateParticipantTheme } from '../util/update_participant_theme'

/**
 * Detect changes to the active presenter and if they have a custom theme
 */
export default function CustomThemeDispatcher (app) {
  const { role } = store.getState()[appSlice.name]

  if (['participant', 'embed'].includes(role)) {
    listenToSelector((state) => selectCustomStyle(state), (customStyle) => {
      updateParticipantTheme(customStyle, app)
    })
  }
}
